import Entity from "@/services/westore/entities/entity";

export class Inventory extends Entity {
  static uri = "/product-variants";

  static store(payloadRequest) {
    return super.create(Inventory.uri, payloadRequest);
  }

  static getOne(id, params = {}) {
    return super.get(Inventory.uri, id, params);
  }

  static getAll(params = {}) {
    return super.getAll(Inventory.uri, params);
  }
  static getTransactions(params = {},id) {
    return super.getAll(`${Inventory.uri}/${id}/transactions`, params);
  }

  static cancel(id) {
    let uri = `${Inventory.uri}/${id}/cancel`;
    return super.put({ uri });
  }

  static getOptions(params = {}) {
    return super.getAll(`${Inventory.uri}/options`, params);
  }

  static filter(params = {}) {
    return super.getAll(`${Inventory.uri}`, params);
  }

  static export(params = {}) {
    const endpoint = `${Inventory.uri}/export`;
    return super.get(endpoint, null, params);
  }
  static exportOne(params = {}, id) {
    const endpoint = `${Inventory.uri}/export/${id}`;
    return super.get(endpoint, null, params);
  }
}

